import { useCallback, useEffect, useState } from 'react';

const KEY = 'v2-theme';
type Theme = 'light' | 'dark';

const initial = (): Theme => {
  try {
    const saved = localStorage.getItem(KEY);
    if (saved === 'light' || saved === 'dark') return saved;
  } catch { /* localStorage có thể bị chặn */ }
  return window.matchMedia?.('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';
};

/**
 * Token màu gắn vào <html> (không phải một div) để các lớp Radix render qua
 * portal (Sheet/Dialog) cũng nhận được biến CSS. Gỡ khi rời v2 → bản cũ không bị ảnh hưởng.
 */
export const useTheme = () => {
  const [theme, setTheme] = useState<Theme>(initial);

  useEffect(() => {
    const el = document.documentElement;
    el.classList.add('v2-root');
    return () => { el.classList.remove('v2-root', 'dark'); };
  }, []);

  useEffect(() => {
    document.documentElement.classList.toggle('dark', theme === 'dark');
    document.querySelector('meta[name="theme-color"]')?.setAttribute('content', theme === 'dark' ? '#17110F' : '#C62F1B');
    try { localStorage.setItem(KEY, theme); } catch { /* bỏ qua */ }
  }, [theme]);

  const toggle = useCallback(() => setTheme(t => (t === 'dark' ? 'light' : 'dark')), []);
  return { theme, toggle };
};
